<template>
    <div class="section__inner-bg">
        <div class="profile-info-item mb-0">
            <div class="profile-info-item__title-wrapper">   
                <h4 class="profile-info-item__title mb-0"><i class="fas fa-heart"></i>
                    最近のユーザー評価
                    <template v-if="!!userRatingsCount">({{userRatingsCount}})</template>
                </h4>
                <div v-if="!!userRatingsCount && userRatingsCount > 0" >
                    <p class="profile-info-item__average-rating">
                        <span>{{ userAverageRating }}</span>
                        <span style="font-size: 12px"> / 平均</span>
                    </p>
                </div>
            </div>
        </div>

        <div class="rating-list"> 
            <template v-for="(userRating, index) in userRatings">
                <div v-if="!!userRating" class="rating-list-item" :key="`rating-${index}`"> 
                    <div class="rating-list-item__header"> 
                        <div :style="`background-image:url(${userRating.user.image});`" alt="rating" class="rating-list-item__user-icon"></div>
                    </div>
                    <div class="rating-list-item__body">   
                        <div class="rating-list-item__info">
                            <span class="rating-list-item__user-name">{{userRating.user.name}}</span>
                            <div class="rating-list-item__stars">
                                <i v-for="index in userRating.totalRate" class="fas fa-star filled" :key="`filled-star-${index}`"></i><i v-for="index in 5 - userRating.totalRate" class="fas fa-star" :key="`star-${index}`"></i>  
                            </div>
                        </div>
                        <p class="rating-list-item__date">
                             {{ userRating.ticket.domainI18n }} / {{ userRating.formattedCreatedAt }}
                        </p>
                        <p class="rating-list-item__comment">
                            {{ userRating.comment }}
                        </p>
                    </div>
                </div>
            </template>
            <div v-if="!userRatings || userRatings.length == 0" class="content-not-found">
                ユーザーによる評価はまだありません
            </div>         
        </div>
        <button @click="scrollUserRatings" class="loadmore-btn">もっと読み込む</button>
  </div>
</template>

<script>
import axios from 'packs/axios'
import Modal from 'packs/components/modal/modal.vue'
import SpinnerWithOverlay from 'packs/components/utility/spinner-with-overlay.vue'

export default {
  components: {
    Modal, SpinnerWithOverlay
  },
  data: function() {
    return {
        userRatingsCount: "",
        userAverageRating: "",
        isLoading: false,
        showModal: false,
        showConfirmationModal: false,
        modalType: "normal",
        modalSuccess: false,
        modalMessage: "",
        userRatings: [],
        selectedUserIdentifiedChar: "",
        userRatingLoadable: true,
    }
  },
  computed: {
    ratingUrl(){
      return `https://${location.host}/user/rating/market`
    }
  },
  created() {  
    const element = document.getElementById("recent-rating-list");
    const data = JSON.parse(element.getAttribute('data'));
    this.selectedUserIdentifiedChar = data.userIdentifiedChar;
    this.fetchUserRatings();
  },
  methods: {
    fetchUserRatings: function(){
        var self = this;
        const queries = {
            user_identified_char: this.selectedUserIdentifiedChar,
            kind: "player_rating",
            offset: this.userRatings.length
        }
        axios.get("/api/v1/user_ratings/recent", {params: queries})
        .then(function(res) {
            self.isLoading = false;
            self.userRatings.push(...res.data.userRatings)
            self.userRatingLoadable = res.data.userRatingLoadable
            self.userRatingsCount = res.data.userRatingsCount
            self.userAverageRating = res.data.userAverageRating
        }).catch((err) => {   
            this.isLoading = false;                 
        })
    },
    closeModal: function() {
       this.showConfirmationModal = false;
       this.showModal = false;
    },
    showErrorModal(msg){
      this.showModal = true;
      this.modalType = "normal";
      this.modalSuccess = false;
      this.modalMessages = msg;
    },
    scrollUserRatings(){
        let element = document.getElementById('rating-list');
        element.scrollIntoView(true);
    }
  }
}
</script>

<style scoped lang="scss">
    .rating-list-item{
        display: flex;
        width: 100%;
        padding: 20px 0;
        border-bottom: 1px solid rgba(255,54,84, .1);  
        @media(max-width: 567px){
            padding: 16px 0;
        }
    }
</style>
